// utils/storeInjector.js
let store = null;

export const injectStore = (_store) => {
  store = _store;
};

export const getStore = () => {
  return store; // If this returns null, the dispatch call fails
};